export const GET_USERMACHINE_REQUEST = "GET_USERMACHINE_REQUEST";
export const GET_USERMACHINE_SUCCESS = "GET_USERMACHINE_SUCCESS";
export const GET_USERMACHINE_FAILURE = "GET_USERMACHINE_FAILURE";

export const CREATE_USERMACHINE_REQUEST = "CREATE_USERMACHINE_REQUEST";
export const CREATE_USERMACHINE_SUCCESS = "CREATE_USERMACHINE_SUCCESS";
export const CREATE_USERMACHINE_FAILURE = "CREATE_USERMACHINE_FAILURE";

export const UPDATE_USERMACHINE_REQUEST = "UPDATE_USERMACHINE_REQUEST";
export const UPDATE_USERMACHINE_SUCCESS = "UPDATE_USERMACHINE_SUCCESS";
export const UPDATE_USERMACHINE_FAILURE = "UPDATE_USERMACHINE_FAILURE";

export const DELETE_USERMACHINE_REQUEST = "DELETE_USERMACHINE_REQUEST";
export const DELETE_USERMACHINE_SUCCESS = "DELETE_USERMACHINE_SUCCESS";
export const DELETE_USERMACHINE_FAILURE = "DELETE_USERMACHINE_FAILURE";

export const GET_LABELS_WITH_PAGINATION_REQUEST =
  "GET_LABELS_WITH_PAGINATION_REQUEST";
export const GET_LABELS_WITH_PAGINATION_SUCCESS =
  "GET_LABELS_WITH_PAGINATION_SUCCESS";
export const GET_LABELS_WITH_PAGINATION_FAILURE =
  "GET_LABELS_WITH_PAGINATION_FAILURE";

export const GET_PRINTERS_FOR_LABEL_REQUEST = "GET_PRINTERS_FOR_LABEL_REQUEST";
export const GET_PRINTERS_FOR_LABEL_SUCCESS = "GET_PRINTERS_FOR_LABEL_SUCCESS";
export const GET_PRINTERS_FOR_LABEL_FAILURE = "GET_PRINTERS_FOR_LABEL_FAILURE";

export const GET_USERS_FOR_PO_REQUEST = " GET_USERS_FOR_PO_REQUEST";
export const GET_USERS_FOR_PO_SUCCESS = " GET_USERS_FOR_PO_SUCCESS";
export const GET_USERS_FOR_PO_FAILURE = " GET_USERS_FOR_PO_FAILURE";
